// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogCategoryEditCell from "./CatalogCategoryEditCell.res.js";

function keyExtractor(row) {
  return row.shopId + "-organisation";
}

let Row = {
  keyExtractor: keyExtractor
};

let columns = [
  {
    key: "shopname",
    name: I18n.t("Shop/Warehouse"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 150
      },
      margin: "large"
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: param.data.shopName
    })
  },
  {
    key: "category",
    name: I18n.t("Category"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 140
      }
    },
    render: param => {
      let match = param.data;
      return JsxRuntime.jsx(CatalogCategoryEditCell.make, {
        variation: "important",
        value: match.categoryName,
        productId: match.productId,
        shopId: match.shopId
      });
    }
  }
];

function CatalogProductOrganisationTableCard(props) {
  let rows = props.shopsProduct.map(product => ({
    productId: product.id,
    shopId: product.shopId,
    shopName: product.shopName,
    categoryId: product.categoryId,
    categoryName: product.formattedCategoryName
  }));
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(TableView.make, {
        data: {
          TAG: "Done",
          _0: {
            TAG: "Ok",
            _0: rows
          }
        },
        columns: columns,
        keyExtractor: keyExtractor,
        hideCard: true
      }),
      spaceTop: "small"
    }),
    title: "Organisation",
    variation: "table"
  });
}

let make = React.memo(CatalogProductOrganisationTableCard);

let Config;

export {
  Config,
  Row,
  columns,
  make,
}
/* columns Not a pure module */
